export const ACTIONS = {
    RESET: 'RESET',
    SET_DATA: 'SET_DATA',
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    SET_LANGUAGE: 'SET_LANGUAGE',
    RESTORE_STATE: 'RESTORE_STATE'
};